<script>
    export let url = null;
    export let title = null;
    export let color = null;

    /**
     *  List item icon
     *  - Only https://heroicons.com/ are supported
     *  - Icon should only consist of a non-`<svg>` part of heroicons
     * 	  - Paste heroicon
     * 	  - Remove `<svg>` and `</svg>` from it
     */
    export let icon = null;
    export let image = null;
    export let animateIcon = true;
    export let isDisabled = false;
    export let isBeta = false;

    export let value = null;
    export let onClick = null;
    export let openInNewTab = true;
    export let linkIcon =
        '<path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />';
    export let id = null;

    let isToggle = typeof value == "boolean";

    // NOTE: for and id are not working as unique in this case for some reason
    let randomId = Math.random().toString(36).substring(7);
</script>

<a
    class="menu-item"
    href={url}
    target={openInNewTab ? "_blank" : "_self"}
    rel="noreferrer"
    {id}
    on:click={onClick}
    class:menu-item--pointer={onClick}
    class:yellow={color == "yellow"}
    class:pink={color == "pink"}
    class:blue={color == "blue"}
    class:disabled={isDisabled}
>
    {#if icon}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="menu-item-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
        >
            {@html icon}
        </svg>
    {/if}

    {#if image}
        <img src={image} alt="menu icon" class="menu-item-icon" />
    {/if}

    <span class="menu-item-title">
        {title}
    </span>

    {#if isBeta}
        <span class="menu-item-badge">
            BETA
        </span>
    {/if}

    {#if isDisabled}
        <!-- ignore -->
        <!-- 
            HACK: it would be a better way to handle !onClick differently below but I'm not
                  sure why it's done the way it's done, and because this is a quick feature
                  for a prosperous customer, we'll make this scalable in the future.
        -->
    {:else if isToggle}
        <label for={"toggle-input-" + randomId} class="toggle">
            <!-- toggle -->
            <div class="toggle-button">
                <!-- input -->
                <input
                    id={"toggle-input-" + randomId}
                    class="toggle-input"
                    type="checkbox"
                    bind:checked={value}
                />

                <!-- line -->
                <div class="toggle-line"></div>
                <!-- dot -->
                <div class="toggle-dot"></div>
            </div>
        </label>
    {:else if !onClick}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="menu-item-arrow"
            class:animate-menu-item-arrow={animateIcon}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
        >
            {@html linkIcon}
        </svg>
    {/if}
</a>

<style>
    @import "../main.css";

    .menu-item-icon {
        @apply reset text-inherit h-4 w-4 !important;
    }

    .menu-item-title {
        @apply reset text-inherit ml-2 text-sm mr-auto !important;
    }

    .menu-item-badge {
        @apply rounded-sm bg-sky-200 text-sky-400 px-1 py-0.5 text-3xs font-black mr-2 leading-normal !important;
    }

    .menu-item {
        @apply reset flex select-none flex-row items-center border-b border-solid border-gray-200 bg-white py-2 pl-4 pr-2 text-black no-underline hover:bg-gray-100 !important;
    }
    .menu-item--pointer {
        @apply cursor-pointer !important;
    }
    .menu-item.yellow {
        @apply border-yellow-200 bg-yellow-100 text-yellow-800 hover:bg-yellow-200 !important;
    }
    .menu-item.pink {
        @apply border-pink-200 bg-pink-100 text-pink-800 hover:bg-pink-200 !important;
    }
    .menu-item.blue {
        @apply border-sky-200 bg-sky-100 text-sky-800 hover:bg-sky-200 !important;
    }
    .menu-item.disabled {
        @apply bg-gray-100 text-gray-500 !important;
    }

    .menu-item-arrow {
        @apply reset ml-auto mr-2 h-4 w-4 transition-all duration-300 !important;
    }

    .menu-item:hover .animate-menu-item-arrow {
        @apply mr-0 !important;
    }

    .toggle {
        @apply reset mr-2 flex cursor-pointer items-center !important;
    }

    .toggle-button {
        @apply relative !important;
    }

    .toggle-line {
        @apply h-4 w-8 rounded-full bg-gray-200 shadow-inner !important;
    }

    .toggle-dot {
        @apply absolute left-0 top-0 h-4 w-4 rounded-full bg-white shadow transition !important;
    }

    .toggle-input {
        @apply sr-only !important;
    }

    .toggle-input:checked ~ .toggle-dot {
        transform: translateX(100%) !important;
        background-color: #ff5290 !important;
    }
</style>
